import * as React from "react"
import * as ReactDOM from "react-dom"
import {applyMiddleware, createStore, Store} from "redux";
import thunkMiddleware from "redux-thunk"
import * as _ from "lodash"

import {CallJs} from "../../lib/types"
import {
	CollationType, OwnProps, PaymentType, PricingOption, ProcessFormApp, ProcessFormStore,
	State, Status
} from "./process-form/app";
import {reducer, validate} from "./process-form/reducer";
import {toString, toStrings, withDefault} from "../../lib/utils";
import {CommandCaller} from "../../lib/commands";

export type PricingOptionDataCallJs = {
	id: string|number
	displayName: string
}

export type StatusDataCallJs  = {
	id: string|number
	name: string
	color: string
}

type UniqueId = string

type ProcessFormProps = {
	uniqueid: UniqueId
	processId: number
	name: string
	pricingOptions: PricingOptionDataCallJs[]
	selectedPricingOptions: (string|number)[]
	disabledPricingOptions: (string|number)[]
	statuses: StatusDataCallJs[]
	selectedStatuses: (string|number)[]
	paymentTypes: PaymentType[]
	selectedPaymentType: PaymentType
	processDays: number
	collationType: CollationType
	sendEmails: boolean
	enabled: boolean
	dataGridId: string
	ajaxUrl: string
	returnUrl: string
}

type AjaxUrl = string
const stores: {[K in UniqueId]?: {store: Store<State>, ajaxUrl: AjaxUrl}} = {}

export const runProcessTest = (uniqueId: string, time: number, ix: number = 1) => async (cb: (dangerousHtml: string) => void) => {
	if (!stores.hasOwnProperty(uniqueId)) {
		setTimeout(() => runProcessTest(uniqueId, time, ix * 2), ix)
		return
	}

	const info = stores[uniqueId]!
	const state = info.store.getState()

	const response = await new CommandCaller(info.ajaxUrl).runGet('getProcessTestData', {
		days: state.processDays,
		beforeAfter: state.processDirection,
		collation: state.collationType,
		pricingOptions: state.selectedPricingOptions,
		paymentType: state.selectedPaymentType,
		statuses: state.selectedStatuses,
		time: time
	}) as {content: string}

	cb(response.content)
}

export const runProcessForm: CallJs<ProcessFormProps> = (replace, params) => {
	const pricingOptions = params.pricingOptions.map<PricingOption>(po => ({id: toString(po.id), label: po.displayName}))
	const statuses = params.statuses.map<Status>(s => ({id: toString(s.id), label: s.name, color: s.color}))
	const paymentTypes = params.paymentTypes

	const ownProps = (store: ProcessFormStore, dataGridId: string): OwnProps => {
		return {
			refreshSampleGrid:  _.debounce(() => new HtmlDataGrid(dataGridId).refresh(), 600),
			disabledPricingOptions: toStrings(params.disabledPricingOptions),
			paymentTypes,
			store,
			returnUrl: params.returnUrl,
			ajaxUrl: params.ajaxUrl,
		}
	}

	const initialState: State = validate({
		processId: params.processId,
		name: params.name,
		pricingOptions,
		multiPricingOption: params.selectedPricingOptions.length > 1,
		selectedPricingOptions: toStrings(params.selectedPricingOptions),
		statuses,
		multiStatus: params.selectedStatuses.length > 1,
		selectedStatuses: toStrings(params.selectedStatuses),
		selectedPaymentType: params.selectedPaymentType,
		processDays: toString(Math.abs(params.processDays)),
		processDirection: params.processDays > 0 ? 'after' : 'before',
		collationType: params.collationType,
		sendEmails: params.sendEmails,
		enabled: params.enabled,
		submitting: false
	})

	const div = document.createElement('div')
	replace(div)

	const store = createStore(withDefault(reducer, initialState), initialState, applyMiddleware(thunkMiddleware))
	stores[params.uniqueid] = {store: store, ajaxUrl: params.ajaxUrl}

	ReactDOM.render(<ProcessFormApp {...ownProps(store, params.dataGridId)}/>, div)
}



// WEBPACK FOOTER //
// ./src/membership3/auto-renewal/process-form.tsx